import React, { useEffect, useState } from 'react';
import { getRemainingTime } from '../utils/CountDownTimer';

import './MUNTimer.scss';

// import image from './../../images/WAS.png';

const defaultRemainingTime = {
  seconds: '00',
  minutes: '00',
  hours: '00',
  days: '00',
};

// let miliSec = 1665655200000 // calculated for october 13, 2022
let date;
let miliSec;

const MUNTimer = () => {
  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);
  const [mun, setMun] = useState([]);

  useEffect(() => {
    fetch('http://localhost:8080/muns/mun')
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed to fetch mun.');
        }
        return res.json();
      })
      .then((resData) => {
        setMun(resData);

        // console.log('resData:', resData);
        // console.log(mun);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (mun.muns) {
    date = mun.muns[0].date;
  }

  const dateExtracted = new Date(date);
  miliSec = dateExtracted.getTime();

  date = new Date(date).toLocaleDateString('en-us', {
    // weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  // console.log(miliSec);

  useEffect(() => {
    const intervalId = setInterval(() => {
      updateRemainingTime(miliSec);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [miliSec]);

  const updateRemainingTime = (countDown) => {
    // console.log('dsgdfg');
    setRemainingTime(getRemainingTime(countDown));
  };

  return (
    <div className="MUNTimer">
      <h2 className="MUNTimer__title">Priority booking closes in</h2>
      <div className="MUNTimer__loading">
        <div className="MUNTimer__loading-fill"></div>
      </div>
      <div className="MUNTimer__time">
        <span className="MUNTimer__time-item">{remainingTime.days}</span>
        <span className="MUNTimer__time-item">:</span>
        <span className="MUNTimer__time-item">{remainingTime.hours}</span>
        <span className="MUNTimer__time-item">:</span>
        <span className="MUNTimer__time-item">{remainingTime.minutes}</span>
        <span className="MUNTimer__time-item">:</span>
        <span className="MUNTimer__time-item">{remainingTime.seconds}</span>
      </div>
      <div className="MUNTimer__units">
        <span className="MUNTimer__units-days">Days</span>
        <span className="MUNTimer__units-hours">Hours</span>
        <span className="MUNTimer__units-minutes">Minutes</span>
        <span className="MUNTimer__units-seconds">Seconds</span>
      </div>
      <p className="MUNTimer__text">
        *Priority registration customers will enjoy &nbsp;
        <a href="#" className="MUNTimer__link">
          added benefits
        </a>
        &nbsp; WITHOUT any added costs.
      </p>
    </div>
  );
};

export default MUNTimer;
